import * as React from 'react';
import { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import { Alert, Button, Card, CardBody, CardText, CardTitle, Col, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';
import Swal from 'sweetalert2';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import {
    Afr, AuditMessage, Certification, commitAfr, generateLocalStateFromEventProperties, getSelectedAfr,
    getVersionPropertiesChanged, isAFRAuditRequired, saveCertification, thirdPartyNotifyLGEs, updateVersionStateValue
} from '../../redux/AfrSlice';
import { resetConceptState } from "../../redux/ConceptSlice";
import { ContactInfo } from '../../redux/ContactSlice';
import { DocumentRelationship } from '../../redux/DocumentsSlice';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { isAdmin, isDirty, setIsDirty } from '../../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { EntityAuthorization, selectUserEntityAuthorizations, selectUserLogged, AdminUserRoleEnum, selectAdminUserRole } from '../../redux/UserSlice';
import { logerUser } from '../../redux/UsersSlice';
import { ErrorSummaryAFRSection, getErrorList, getTotalErrorCount, setDisplayErrors, updateErrors } from '../../redux/ValidationSlice';
import enums from '../../utils/enums';
import utilityHelper from '../../utils/utilityHelper';
import CanShowGivenAfrReportAccess from '../feature/CanShowGivenAfrReportAccess';

const CertificationCore = (props: { userRole: string }) => {
    const dispatch = useAppDispatch();
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const adminUserRole: AdminUserRoleEnum | null = useAppSelector(selectAdminUserRole);
    const taxType: TaxonomyTypeEnum = (currentAfr && currentAfr.taxonomyType) ? currentAfr.taxonomyType : TaxonomyTypeEnum.AFR;
    const loggedUser: logerUser | null = useAppSelector(selectUserLogged);
    const stateChanges = useAppSelector(getVersionPropertiesChanged);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const isAdminUser: boolean = useAppSelector(isAdmin);
    const isDirtyInfo: boolean = useAppSelector(isDirty);
    const auditMessage: AuditMessage = useAppSelector(isAFRAuditRequired);
    const [state, setState] = useState<any>({});
    const [certifiedOneName, setCertifiedOneName] = useState("");
    const [certifiedOneTitle, setCertifiedOneTitle] = useState("");
    const [certifiedTwoName, setCertifiedTwoName] = useState("");
    const [certifiedTwoTitle, setCertifiedTwoTitle] = useState("");
    const [emergency, setEmergency] = useState({ value: "" });
    const [deterioration, setDeterioration] = useState({ value: "" });
    const [showComplianceDD, setShowComplianceDD] = useState(false);
    const [compliance, setCompliance] = useState({ value: "N/A" });
    const [isEdited, setIsEdited] = useState(isDirtyInfo);
    const [certOneAgree, setCertOneAgree] = useState(false);
    const [certTwoAgree, setCertTwoAgree] = useState(false);
    const [textButton, setTextButton] = useState("");
    const [certTitle,setCertTitle] = useState((currentAfr && currentAfr.taxonomyType && currentAfr.taxonomyType === TaxonomyTypeEnum.COURT_REPORTING_29) ? "Court Report 29.0085 Certification" : "Certification");
    const [reportTitle, setReportTitle] = useState((currentAfr && currentAfr.taxonomyType && currentAfr.taxonomyType === TaxonomyTypeEnum.COURT_REPORTING_29) ? "Court Report 29.0085" : "AFR");
    const [phoneNumber, setPhoneNumber] = React.useState<string>("");
    const [phoneExtension, setPhoneExtension] = React.useState<string>("");

    const errorList = useAppSelector(getErrorList);
    const totalErrorCount: any = useAppSelector(getTotalErrorCount);

    const [financialLabel, setFinancialLabel] = useState("");
    const [deteriorationLabel, setDeteriorationLabel] = useState("");

    const auditType: string | null = (currentAfr && currentAfr.currentversion && currentAfr.currentversion.audit) ? currentAfr.currentversion.audit.auditType : "";
    var currentCertification: Certification | null = (currentAfr && currentAfr.currentversion) ? currentAfr.currentversion.certification : null;

    const authorizedEntitiesSelector: Array<EntityAuthorization> | null = useAppSelector(selectUserEntityAuthorizations);
    const [isNotThirdParty, setIsNotThirdParty] = React.useState<boolean>(true);

    const options = ([
        {
            value: "",
            label: '---'
        },
        {
            value: "TRUE",
            label: 'Yes'
        },
        {
            value: "FALSE",
            label: 'No'
        }
    ]);

    const defaultDropDownValue = { label: "---", value: "" };

    const showUploadSuccessful = function () {
        let rname = utilityHelper.getReportTypeName(currentAfr);
        Swal.fire(
            "Submit " + rname,
            rname + " submitted successfully.",
            'success'
        );
    }

    const showUploadHasErrors = function () {
        let rname = utilityHelper.getReportTypeName(currentAfr);
        Swal.fire(
            "Submit " + rname,
            rname + " submission NOT successful. The submitted report has errors. Please see the Errors Section or AFR Assistance window for details.",
            'error'
        );
    }

    const requiresCertification = function (afr: Afr | null) {
        if (!afr || !afr.taxonomyType) {
            return false;
        }
        var bResult = false;
        switch (afr.taxonomyType) {
            case TaxonomyTypeEnum.AFR:
                bResult = true;
                break;

            case TaxonomyTypeEnum.COURT_REPORTING_29:
                if (afr.currentversion && afr.currentversion.documents) {
                    var foundDoc = afr.currentversion.documents.find((doc: DocumentRelationship) => doc.role === "CR_29_SIGNED_TEMPLATE");
                    bResult = (foundDoc === undefined);
                } else {
                    bResult = true;
                }
                break;

            default:
                bResult = false;
        }
        return bResult;
    }
    const handleChangeCheckbox = function (event: any) {

        var checkValues = JSON.parse(JSON.stringify(state));
        var key: string = event.target.name;
        var value: boolean = event.target.checked
        checkValues[key] = value;

        setState(checkValues);

        // here call to dispatcher sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]

        // Update global flag for this event in redux
        dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));

        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }))

    }

    /* Opening the first section with errors */
    const handleClickShowErrors = function (e: any) {

        var globalErrors: Array<ErrorSummaryAFRSection> = JSON.parse(JSON.stringify(errorList));
        var indexCount = 0;
        var sectionFound = false;

        for (var index in globalErrors) {
            globalErrors[index].section.sectionIsOpen = false;
            if (globalErrors[index].sectionErrorCount > 0 && !sectionFound) {
                globalErrors[index].section.sectionIsOpen = true;
                sectionFound = true;
            }

            indexCount = indexCount + 1;
        }

        if (indexCount > 0) {
            dispatch(updateErrors(globalErrors));
        }
        dispatch(setDisplayErrors(true));
    }

    /* Submit action */
    const handleSaveClick = () => {
        if (!(currentAfr && currentAfr.currentversion)) {
            return;
        }

        if (currentAfr) {
            var commitCall = {
                currentAfr: currentAfr,
                changedVersionStates: stateChanges,
                submit: true
            }
            dispatch(commitAfr(commitCall))
                .then((result: any) => {
                    dispatch(resetConceptState({}));
                    //reset the dirty flag
                    dispatch(setIsDirty({ IsDirty: false, Page: "" }));
                    if (result.payload.status === "IN_PROGRESS") {
                        // We're supposed to be submitting, so if our current status is IN_PROGRESS there is an error
                        showUploadHasErrors();
                    } else {
                        showUploadSuccessful();
                    }
                });
        }
    }
    const handleChange = function (event: React.FocusEvent<HTMLInputElement>) {

        var value = event.target.value;

        setIsEdited(true);
        switch (event.target.name.toLowerCase()) {
            case "certifiedonename":
                setCertifiedOneName(value);
                break;
            case "certifiedonetitle":
                setCertifiedOneTitle(value);
                break;
            case "certifiedtwoname":
                setCertifiedTwoName(value);
                break;
            case "certifiedtwotitle":
                setCertifiedTwoTitle(value);
                break;
            case "phoneextension":
                setPhoneExtension(value);
                break;
        }

    }
    const updatePhoneNumber = function (value: string) {
        setIsEdited(true);
        setPhoneNumber(value);
    }

    const updatePhoneExtension = function (value: string) {
        setIsEdited(true);
        setPhoneExtension(value);
    }

    const handleChangeDD = function (event: any, action: any) {
        if (!(currentAfr && currentAfr.currentversion)) {
            return;
        }

        var updCertification: Certification = {
            financialEmergency: null, compliance218: null, financialDeterioration: null, submittedDocumentation: null, icertify: null, firstCertifier: null, secondCertifier: null
        }

        if (currentAfr && currentAfr.currentversion && currentAfr.currentversion.certification) {
            updCertification = JSON.parse(JSON.stringify(currentAfr.currentversion.certification));
        }

        if (action.name === 'EMERGENCY') {
            setEmergency({ value: event.value });

            setShowComplianceDD(false);
            if (event.value === 'TRUE') {
                updCertification.financialEmergency = true;
                updCertification.compliance218 = "TRUE";
                setShowComplianceDD(true);

            } else {
                updCertification.financialEmergency = false;
                updCertification.compliance218 = "NA";
                setCompliance({ value: "N/A" });
            }
        } else if (action.name == 'DETERIORATION') {
            updCertification.financialDeterioration = (event.value === "TRUE");
            setDeterioration({ value: event.value });
        } else {
            updCertification.compliance218 = event.value;
            setCompliance({ value: event.value });
        }

        // Update Certification in Redux
        dispatch(saveCertification(updCertification));

        if (!isDirtyInfo) {
            // Turn ON the dirty flag in redux
            dispatch(setIsDirty({ IsDirty: true, Page: "" }));
        }


    }
    const createContactInfo = function (): ContactInfo | null {
        if (phoneNumber.length === 0) {
            return null;
        }
        var ci: ContactInfo = {
            number: { number: phoneNumber, extension: phoneExtension },
            email: ""
        };
        return ci;
    }
    const handleBlur = function (event: React.FocusEvent<HTMLInputElement>) {

        if (!(currentAfr && currentAfr.currentversion)) {
            return;
        }

        var value = event.target.value;
        var updCertification: Certification = {
            financialEmergency: null, compliance218: "", financialDeterioration: null, submittedDocumentation: "",
            icertify: null, firstCertifier: { title: "", name: "", agree: null, contactInfo: createContactInfo() }, secondCertifier: { title: "", name: "", agree: null, contactInfo: null }
        }

        if (currentAfr && currentAfr.currentversion && currentAfr.currentversion.certification) {
            updCertification = JSON.parse(JSON.stringify(currentAfr.currentversion.certification));
            if (!updCertification.firstCertifier) {
                updCertification.firstCertifier = { title: "", name: "", agree: null, contactInfo: null };
            }
            if (!updCertification.secondCertifier) {
                updCertification.secondCertifier = { title: "", name: "", agree: null, contactInfo: null };
            }
        }

        switch (event.target.name.toLowerCase()) {
            case "certifiedonename":
                if (updCertification.firstCertifier != null) {
                    updCertification.firstCertifier.name = value;
                }
                break;
            case "certifiedonetitle":
                if (updCertification.firstCertifier != null) {
                    updCertification.firstCertifier.title = value;
                }
                break;
            case "certifiedtwoname":
                if (updCertification.secondCertifier != null) {
                    updCertification.secondCertifier.name = value;
                }
                break;
            case "certifiedtwotitle":
                if (updCertification.secondCertifier != null) {
                    updCertification.secondCertifier.title = value;
                }
                break;
            case "phonenumber":
                if (updCertification.firstCertifier != null) {
                    if (updCertification.firstCertifier.contactInfo === null) {
                        updCertification.firstCertifier.contactInfo = createContactInfo();
                    } else {
                        updCertification.firstCertifier.contactInfo.number.number = value;
                    }
                }
                break;
            case "phoneextension":
                if (updCertification.firstCertifier != null) {
                    if (updCertification.firstCertifier.contactInfo === null) {
                        updCertification.firstCertifier.contactInfo = createContactInfo();
                    } else {
                        updCertification.firstCertifier.contactInfo.number.extension = value;
                    }
                }
                break;
        }

        // Update Certification in Redux
        dispatch(saveCertification(updCertification));

        if (isEdited && !isDirtyInfo) {
            // Turn ON the dirty flag in redux
            dispatch(setIsDirty({ IsDirty: true, Page: "" }));
        } 

    }

    const shouldDisableSubmit = function (): boolean {
        if ((!isDirtyInfo) && ((adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin))){
            return true;
        }
        return !(utilityHelper.evaluateAllSectionOK(loggedUser, currentAfr, entity, errorList, auditMessage, dispatch))
    }
    const IsInputTextValid = (textValue: string): boolean | undefined => {
        var isValid : boolean | undefined = undefined;
        if (!isCertificationLock()) {
            if (textValue) {
                if (textValue.trim().length > 0) {
                    isValid = true;
                }
                else {
                    isValid = false;
                }
            }
            else {
                isValid = false;
            }
        }
        return isValid
    }

    const IsInputTextInvalid = (textValue: string | undefined): boolean | undefined => {
        var isInvalid : boolean | undefined = undefined;

        if (!isCertificationLock()) {
            if (textValue) {
                if (textValue.trim().length <= 0) {
                    isInvalid = true;
                }
                else {
                    isInvalid = false;
                }
            }
            else {
                isInvalid = true;
            }
        }

        return isInvalid
    }


    useEffect(() => {
        var btnText = "";
        switch(taxType) {
            case TaxonomyTypeEnum.COURT_REPORTING_29:
                setCertTitle("Court Report 29.0085 Certification");
                setReportTitle("Court Report 29.0085");
                btnText = "Submit Court Report 29.0085";
                break;

            default:
                setCertTitle("Certification");
                setReportTitle("AFR");
                btnText = "Submit AFR";
                break;
        }
        setCertifiedOneName("");
        setCertifiedOneTitle("");
        setCertifiedTwoName("");
        setCertifiedTwoTitle("");
        setPhoneNumber("");
        setPhoneExtension("");
        setShowComplianceDD(false);
        setCertOneAgree(false);
        setCertTwoAgree(false);
        setTextButton(btnText);

 //       if (isDirtyInfo) { setTextButton("Save and " + btnText); }

        if (currentCertification) {
            var valueOpc = ((currentCertification.financialEmergency === true) ? currentCertification.financialEmergency.toString().toUpperCase() : "FALSE");
            setFinancialLabel("No");
            if (valueOpc === 'TRUE') {
                setFinancialLabel("Yes");
                setShowComplianceDD(true);
            }
            setEmergency({ value: valueOpc });
            valueOpc = (((currentCertification.compliance218 != null ? currentCertification.compliance218.toUpperCase() : "") + "" === 'NA') ? 'N/A'
                : (currentCertification.compliance218 != null ? currentCertification.compliance218.toUpperCase() : "") + "")
            setCompliance({ value: valueOpc });
            valueOpc = ((currentCertification.financialDeterioration === true) ? currentCertification.financialDeterioration.toString().toUpperCase() : "FALSE");
            setDeteriorationLabel("No");
            if (valueOpc === 'TRUE') {
                setDeteriorationLabel("Yes");
            }
            setDeterioration({ value: valueOpc });
        }



        if (currentCertification && currentCertification.firstCertifier) {
            setCertifiedOneName(currentCertification.firstCertifier.name);
            setCertifiedOneTitle(currentCertification.firstCertifier.title);
            if (currentCertification.firstCertifier.agree) {
                setCertOneAgree(true);
            }
            var ci = currentCertification.firstCertifier.contactInfo;
            if (ci && ci.number) {
                setPhoneNumber(ci.number.number);
                setPhoneExtension(ci.number.extension);
            }
        }
        if (currentCertification && currentCertification.secondCertifier) {
            setCertifiedTwoName(currentCertification.secondCertifier.name);
            setCertifiedTwoTitle(currentCertification.secondCertifier.title);
            if (currentCertification.secondCertifier.agree) {
                setCertTwoAgree(true);
            }

        }

    }, [currentCertification]);


    useEffect(() => {

        // get state from redux
        if (currentAfr) {
            if (currentAfr.taxonomyType == TaxonomyTypeEnum.COURT_REPORTING_29) { 
                var newLocalState = generateLocalStateFromEventProperties(currentAfr, ["reviewState_cr29CertificationReviewed"])
            }
            else {
                var newLocalState = generateLocalStateFromEventProperties(currentAfr, ["reviewState_certificationReviewed"])
            }
        }

        // create a local state from redux
        setState(newLocalState);

        setIsEdited(false);

    }, [currentAfr]);

    const isCertificationLock = function (): boolean {
        return utilityHelper.isLockedCertification(currentAfr, (loggedUser != null ? loggedUser.role : ""));
    }

    const isCertificationReviewLock = function (): boolean {
        if (!currentAfr) {
            return true;
        }
        if (utilityHelper.isLockedCertification(currentAfr, (loggedUser != null ? loggedUser.role : ""))) {
            return true;
        };
        if (utilityHelper.checkStatusList(currentAfr, enums.certifiedRecertified)) {
            return false;
        }
        return true;
    }

    const handleNotifyClick = () => {
        if (currentAfr != null && entity != null && entity.code != null) {

            dispatch(thirdPartyNotifyLGEs(currentAfr.afrId))
                .then((result: any) => {
                    if (result.payload != null && result.payload == "Notification Email(s) Sent") {
                        Swal.fire('Notification Sent', '', 'info');
                    }
                    else {
                        Swal.fire('Oops...', 'Something went wrong!', 'error')
                    }
                });
        }
    }

    const getDisplayForYesNoAnswerString = (value: string): string => {
        let result: string = "";

        switch (value) {
            case 'NA':
                result = "N/A";
                break;
            case 'TRUE':
                result = "Yes";
                break;
            case 'FALSE':
                result = "No";
                break;
            default:
                result = value;
                break;
        }

        return result;
    }

    React.useEffect(() => {

        if (isAdminUser) {
            setIsNotThirdParty(true);
        }
        else {
            if (entity && authorizedEntitiesSelector) {

                var foundEntityAuthorization = authorizedEntitiesSelector.find((element) => element.entity.code == entity.code);

                if (foundEntityAuthorization) {

                    if (foundEntityAuthorization.entityUserRole == "THIRD_PARTY") {
                        setIsNotThirdParty(false);
                    }
                    else {
                        setIsNotThirdParty(true);
                    }
                }
                else {
                    setIsNotThirdParty(true);
                }
            } else {
                setIsNotThirdParty(true);
            }
        }

    }, [currentAfr])

    const isNotThirdPartyRender = (<React.Fragment>
        {entity != null ? (
            <h3>{certTitle} for {utilityHelper.getEntityName(entity, currentAfr)} ({utilityHelper.getEntityCode(entity, currentAfr)}), {afrYear}</h3>
        ) : (<></>)}

        {isAdminUser &&
            (<div className="box-events pl-2 pr-3 py-3 my-2">
                <div>
                    <Label className="ml-4" check>
                        <Input type="checkbox"
                            name="reviewState_certificationReviewed"
                            onChange={handleChangeCheckbox}
                            checked={state["reviewState_certificationReviewed"]}
                            disabled={isCertificationReviewLock()}
                        /><b>Reviewed</b>
                    </Label>
                </div>
            </div>)}

        <Row>
            <Col>
                <div>
                    <h5>
                        <p>Pursuant to Section 218.32(1)(a), Florida Statutes, to successfully complete and submit the Annual Financial Report (AFR), “The chair of the governing body and the chief financial officer of each local governmental entity shall sign the annual financial report submitted … attesting to the accuracy of the information included in the report.”</p>
                        <p>To complete the Certification requirement, identify and respond to the two legal clauses on this page, input the names and titles of the applicable officers, have the officers identify the terms and conditions that certify the entire AFR and sign off on the package by checking the agreement box.</p>
                        <p>When complete, and the “Submit AFR” button is clicked, you will not be able to update any of the AFR information without contacting DFS.</p>
                    </h5>
                </div>


                <div >
                    <Row>
                        <Col sm="1"></Col>
                        <Col sm="10">
                            <Alert color="info">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-8">
                                            <span>Have you experienced a financial emergency pursuant to </span>
                                            <a href="http://www.leg.state.fl.us/statutes/index.cfm?App_mode=Display_Statute&URL=0200-0299/0218/Sections/0218.503.html" target="_blank">218.503, F.S.,</a>
                                            <span> in this year?</span>
                                        </div>
                                        <div className="col-6 col-md-4 text-right">

                                            {(!((currentAfr &&
                                                (utilityHelper.isAfrAtLeastSubmitted(currentAfr) == true)))
                                                ? (
                                                    <>
                                                        <Select
                                                            value={
                                                                options.filter(function (option) {
                                                                    return option.value === emergency.value;
                                                                })
                                                            }
                                                            name="EMERGENCY"
                                                            isDisabled={isCertificationLock()
                                                                || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                            onChange={handleChangeDD}
                                                            options={options}
                                                        />

                                                        <Input type="hidden"
                                                            value={emergency.value}
                                                            onChange={(e) => { }}
                                                            valid={emergency.value != defaultDropDownValue.value}
                                                            invalid={emergency.value == defaultDropDownValue.value}
                                                            disabled={true}
                                                        />
                                                        <FormFeedback>Required.</FormFeedback>
                                                    </>


                                                )
                                                : utilityHelper.toProperCase(financialLabel))}

                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="col-md-8">
                                            <span>If yes, have you complied with section </span>
                                            <a href="http://www.leg.state.fl.us/statutes/index.cfm?App_mode=Display_Statute&URL=0200-0299/0218/Sections/0218.503.html" target="_blank">218.503(2), F.S.</a>
                                            <span>?</span>
                                        </div>
                                        <div className="col-6 col-md-4 text-right">
                                            {showComplianceDD && utilityHelper.isAfrAtLeastSubmitted(currentAfr) ==  false ? (

                                                <>
                                                    <Select
                                                        value={
                                                            options.filter(function (option) {
                                                                return option.value === compliance.value;
                                                            })
                                                        }
                                                        name="COMPLIANCE"
                                                        isDisabled={((currentAfr &&
                                                            (isCertificationLock())) ? true : false)
                                                            || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin) }
                                                        onChange={handleChangeDD}
                                                        options={options}
                                                    />

                                                    <Input type="hidden"
                                                        value={compliance.value}
                                                        onChange={(e) => { }}
                                                        valid={compliance.value != defaultDropDownValue.value}
                                                        invalid={compliance.value == defaultDropDownValue.value}
                                                        disabled={true}
                                                    />
                                                    <FormFeedback>Required.</FormFeedback>
                                                </>

                                            ) : getDisplayForYesNoAnswerString(compliance.value) }

                                        </div>
                                    </div>
                                    {currentAfr && currentAfr.year > 2021 &&
                                        <div>
                                            <br />
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <span>Have you experienced any deteriorating financial conditions pursuant to </span>
                                                    <a href="http://www.leg.state.fl.us/statutes/index.cfm?App_mode=Display_Statute&URL=0200-0299/0218/Sections/0218.39.html" target="_blank">218.39(5)(a), F.S.,</a>
                                                    <span> in this year?</span>
                                                </div>
                                                <div className="col-6 col-md-4 text-right">

                                                    {(!((currentAfr &&
                                                        (utilityHelper.isAfrAtLeastSubmitted(currentAfr) == true)))
                                                        ? (

                                                            <>
                                                                <Select
                                                                    value={
                                                                        options.filter(function (option) {
                                                                            return option.value === deterioration.value;
                                                                        })
                                                                    }
                                                                    name="DETERIORATION"
                                                                    isDisabled={isCertificationLock()
                                                                        || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                                    onChange={handleChangeDD}
                                                                    options={options}
                                                                />
                                                                

                                                                <Input type="hidden"
                                                                    value={deterioration.value}
                                                                    onChange={(e) => { }}
                                                                    valid={deterioration.value != defaultDropDownValue.value}
                                                                    invalid={deterioration.value == defaultDropDownValue.value}
                                                                    disabled={true}
                                                                />
                                                                <FormFeedback>Required.</FormFeedback>
                                                            </>

                                                        )
                                                        : utilityHelper.toProperCase(deteriorationLabel))}

                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <br />
                                    <div className="row">
                                        <div className="col-md-8">
                                            <span>SUPPORTING DOCUMENTATION:</span>
                                        </div>
                                        <div className="col-6 col-md-4 text-right">
                                            {auditType}
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="col">
                                            <p className="font-italic"><b>Terms and Conditions:</b></p>
                                            <p className="font-italic"><b>By electronically providing my signature, I certify, to the best of my knowledge, that the financial information provided herein is accurate and complete. This information can only be amended by a representative of the State’s Chief Financial Officer in conjunction with the management of this government’s financial department unless re-certified by myself.</b></p>
                                        </div>
                                    </div>
                                </div>
                            </Alert>
                            <br />
                        </Col>
                        <Col sm="1"></Col>
                    </Row>
                </div>
                <React.Fragment>
                    <div>
                        <Row>
                            <Col sm="6">
                                <Card body>
                                    <CardTitle><b>Certifier One</b></CardTitle>
                                    <CardBody>
                                        <Row>
                                            <Col md="4" className="text-right">
                                                <Label >Name:</Label>
                                            </Col>
                                            <Col md="8">
                                                <Input type="text" value={certifiedOneName}
                                                    name="certifiedOneName"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    readOnly={isCertificationLock()
                                                        || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="my-3">
                                            <Col md="4" className="text-right">
                                                <Label >Title:</Label>
                                            </Col>
                                            <Col md="8">
                                                <Input type="text" value={certifiedOneTitle}
                                                    name="certifiedOneTitle"
                                                    onBlur={handleBlur} onChange={handleChange}
                                                    readOnly={isCertificationLock()
                                                        || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {certOneAgree
                                                    ? <span>&#9745;</span>
                                                    : <span>&#9744;</span>}
                                                <span> I Agree to the Terms and Conditions Above.</span>
                                            </Col>
                                        </Row>


                                    </CardBody>
                                </Card>
                            </Col>
                            <Col sm="6">
                                <Card body>
                                    <CardTitle><b>Certifier Two</b></CardTitle>
                                    <CardBody>
                                        <Row>
                                            <Col md="4" className="text-right">
                                                <Label >Name:</Label>
                                            </Col>
                                            <Col md="8">
                                                <Input type="text" value={certifiedTwoName}
                                                    name="certifiedTwoName"
                                                    onBlur={handleBlur} onChange={handleChange}
                                                    readOnly={isCertificationLock()
                                                        || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="my-3">
                                            <Col md="4" className="text-right">
                                                <Label >Title:</Label>
                                            </Col>
                                            <Col md="8">
                                                <Input type="text" value={certifiedTwoTitle}
                                                    name="certifiedTwoTitle"
                                                    onBlur={handleBlur} onChange={handleChange}
                                                    readOnly={isCertificationLock()
                                                        || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {certTwoAgree
                                                    ? <span>&#9745;</span>
                                                    : <span>&#9744;</span>}
                                                <span> I Agree to the Terms and Conditions Above.</span>
                                            </Col>
                                        </Row>


                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center pl-2 pr-3 py-1 my-1" >

                                {(totalErrorCount > 0) && !(utilityHelper.isLockedCertification(currentAfr, "")) &&
                                    (!(utilityHelper.evaluateAllSectionOK(loggedUser, currentAfr, entity, errorList, auditMessage, dispatch))) &&
                                    <Alert color="warning">
                                    <p><a className="anchorButton" onClick={handleClickShowErrors}>There are still outstanding items to complete prior to submitting the {reportTitle}.</a></p>
                                    </Alert>}
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center pl-2 pr-3" >
                                <p>
                                    <CanShowGivenAfrReportAccess>
                                        <Button
                                            className="btnSubmit"
                                            type="button"
                                            onClick={handleSaveClick}
                                            disabled={shouldDisableSubmit() || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin )}>{textButton}
                                        </Button>
                                    </CanShowGivenAfrReportAccess>
                                </p>
                            </Col>
                        </Row>
                    </div>
                </React.Fragment>
            </Col>
        </Row>
    </React.Fragment>);

    const isThirdPartyRender = (
        <React.Fragment>
            {entity != null ? (
                <h3>Certification for {utilityHelper.getEntityName(entity, currentAfr)} ({utilityHelper.getEntityCode(entity, currentAfr)}), {afrYear}</h3>
            ) : (<></>)}

            {isAdminUser &&
                (<div className="box-events pl-2 pr-3 py-3 my-2">
                    <div>
                        <Label className="ml-4" check>
                            <Input type="checkbox"
                                name="reviewState_certificationReviewed"
                                onChange={handleChangeCheckbox}
                                checked={state["reviewState_certificationReviewed"]}
                                disabled={isCertificationReviewLock()}
                            /><b>Reviewed</b>
                        </Label>
                    </div>
                </div>)}

            <Row>
                <Col>
                    <div>
                        <h5>
                            <p>Pursuant to Section 218.32(1)(a), Florida Statutes, to successfully complete and submit the Annual Financial Report (AFR), “The chair of the governing body and the chief financial officer of each local governmental entity shall sign the annual financial report submitted … attesting to the accuracy of the information included in the report.”</p>
                            <p>To complete the Certification requirement, identify and respond to the two legal clauses on this page, input the names and titles of the applicable officers, have the officers identify the terms and conditions that certify the entire AFR and sign off on the package by checking the agreement box.</p>
                            <p>When complete, and the “Submit AFR” button is clicked, you will not be able to update any of the AFR information without contacting DFS.</p>
                        </h5>
                    </div>


                    <Row>
                        <Col sm="1"></Col>
                        <Col sm="10">
                            <Alert color="info">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-8">
                                            <span>Have you experienced a financial emergency pursuant to </span>
                                            <a href="http://www.leg.state.fl.us/statutes/index.cfm?App_mode=Display_Statute&URL=0200-0299/0218/Sections/0218.503.html" target="_blank">218.503, F.S.,</a>
                                            <span> in this year?</span>
                                        </div>
                                        <div className="col-6 col-md-4 text-right">

                                            {(!((currentAfr &&
                                                (utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified))))
                                                ? (<Select
                                                    value={
                                                        options.filter(function (option) {
                                                            return option.value === emergency.value;
                                                        })
                                                    }
                                                    name="EMERGENCY"
                                                    isDisabled={isCertificationLock()
                                                        || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                    onChange={handleChangeDD}
                                                    options={options}
                                                />)
                                                : utilityHelper.toProperCase(financialLabel))}

                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="col-md-8">
                                            <span>If yes, have you complied with section </span>
                                            <a href="http://www.leg.state.fl.us/statutes/index.cfm?App_mode=Display_Statute&URL=0200-0299/0218/Sections/0218.503.html" target="_blank">218.503(2), F.S.</a>
                                            <span>?</span>
                                        </div>
                                        <div className="col-6 col-md-4 text-right">
                                            {showComplianceDD && utilityHelper.isAfrAtLeastSubmitted(currentAfr) == false ? (<Select
                                                value={
                                                    options.filter(function (option) {
                                                        return option.value === compliance.value;
                                                    })
                                                }
                                                name="COMPLIANCE"
                                                isDisabled={((currentAfr &&
                                                    (isCertificationLock())) ? true : false)
                                                    || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin) }
                                                onChange={handleChangeDD}
                                                options={options}
                                            />) : getDisplayForYesNoAnswerString(compliance.value)}

                                        </div>
                                    </div>
                                    {currentAfr && currentAfr.year > 2021 &&
                                        <div>
                                            <br />
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <span>Have you experienced any deteriorating financial conditions pursuant to </span>
                                                    <a href="http://www.leg.state.fl.us/statutes/index.cfm?App_mode=Display_Statute&URL=0200-0299/0218/Sections/0218.39.html" target="_blank">218.39(5)(a), F.S.,</a>
                                                    <span> in this year?</span>
                                                </div>
                                                <div className="col-6 col-md-4 text-right">

                                                    {(!((currentAfr &&
                                                        (utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified))))
                                                        ? (<Select
                                                            value={
                                                                options.filter(function (option) {
                                                                    return option.value === deterioration.value;
                                                                })
                                                            }
                                                            name="DETERIORATION"
                                                            isDisabled={isCertificationLock()
                                                                || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                            onChange={handleChangeDD}
                                                            options={options}
                                                        />)
                                                        : utilityHelper.toProperCase(deteriorationLabel))}

                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <br />
                                    <div className="row">
                                        <div className="col-md-8">
                                            <span>SUPPORTING DOCUMENTATION:</span>
                                        </div>
                                        <div className="col-6 col-md-4 text-right">
                                            {auditType}
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="col">
                                            <p className="font-italic"><b>Terms and Conditions:</b></p>
                                            <p className="font-italic"><b>By electronically providing my signature, I certify, to the best of my knowledge, that the financial information provided herein is accurate and complete. This information can only be amended by a representative of the State’s Chief Financial Officer in conjunction with the management of this government’s financial department unless re-certified by myself.</b></p>
                                        </div>
                                    </div>
                                </div>
                            </Alert>
                            <br />
                        </Col>
                        <Col sm="1"></Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button
                                className="btnSubmit"
                                type="button"
                                onClick={handleNotifyClick}>Send Notification
                            </Button>
                        </Col>
                    </Row>

                </Col>
            </Row>
        </React.Fragment>)

    const isCR29Render = (
        <React.Fragment>
            {entity != null ? (
                <h3>Court Report 29.0085 Certification for {entity.name} ({entity.code}), {afrYear}</h3>
            ) : (<></>)}

            {isAdminUser &&
                (<div className="box-events pl-2 pr-3 py-3 my-2">
                    <div>
                        <Label className="ml-4" check>
                            <Input type="checkbox"
                                name="reviewState_cr29CertificationReviewed"
                                onChange={handleChangeCheckbox}
                                checked={state["reviewState_cr29CertificationReviewed"]}
                                disabled={isCertificationReviewLock()}
                            /><b>Reviewed</b>
                        </Label>
                    </div>
                </div>)}
            { requiresCertification(currentAfr)
                ?
                <Row>
                    <Col>
                        <Row>
                            <Col sm="1"></Col>
                            <Col sm="10">
                                <Alert color="info">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col">
                                                <p className="font-italic"><b>Terms and Conditions:</b></p>
                                                <p className="font-italic"><b>This is to certify this report accurately states total expenditures as set for in Sections 29.008 and 29.0085, Florida Statutes, and the auditor’s engagement was conducted pursuant to AICPA standards.</b></p>
                                            </div>
                                        </div>
                                    </div>
                                </Alert>
                                <br />
                            </Col>
                            <Col sm="1"></Col>
                        </Row>
                        <Row>
                            <Col sm="1"></Col>
                            <Col sm="10">
                                <Card body>
                                    <CardTitle><b>Certifier</b></CardTitle>
                                    <CardBody>
                                        <Row>
                                            <Col md="4" className="text-right">
                                                <Label >Name:</Label>
                                            </Col>
                                            <Col md="8">
                                                <FormGroup>
                                                    <Input type="text" value={certifiedOneName}
                                                        name="certifiedOneName"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        readOnly={isCertificationLock()
                                                            || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                        valid={IsInputTextValid(certifiedOneName)}
                                                        invalid={IsInputTextInvalid(certifiedOneName)}
                                                    />
                                                    <FormFeedback>Name is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row className="my-3">
                                            <Col md="4" className="text-right">
                                                <Label >Title:</Label>
                                            </Col>
                                            <Col md="8">
                                                <FormGroup>
                                                    <Input type="text" value={certifiedOneTitle}
                                                        name="certifiedOneTitle"
                                                        onBlur={handleBlur} onChange={handleChange}
                                                        readOnly={isCertificationLock()
                                                            || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                        valid={IsInputTextValid(certifiedOneTitle)}
                                                        invalid={IsInputTextInvalid(certifiedOneTitle)}
                                                    />
                                                    <FormFeedback>Title is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row className="my-3">
                                            <Col md="4" className="text-right">
                                                <Label >Phone Number:</Label>
                                            </Col>
                                            <Col md="8">
                                                <FormGroup>
                                                    <Row>
                                                        <Col md="4">
                                                            <Input
                                                                name="phoneNumber"
                                                                type="tel"
                                                                mask="(999) 999-9999"
                                                                value={phoneNumber}
                                                                tag={InputMask}
                                                                onBlur={handleBlur}
                                                                onChange={(e) => updatePhoneNumber(e.currentTarget.value)}
                                                                disabled={isCertificationLock()
                                                                    || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                                valid={(IsInputTextValid(phoneNumber) && phoneNumber.includes("_") == false)}
                                                                invalid={(IsInputTextInvalid(phoneNumber) || phoneNumber.includes("_") == true)} />
                                                            <FormFeedback>Phone number is required.</FormFeedback>
                                                        </Col>
                                                        <Col md="2" className="text-right">
                                                            <Label>Extension:</Label>
                                                        </Col>
                                                        <Col md="2">
                                                            <Input
                                                                name="phoneExtension"
                                                                value={phoneExtension}
                                                                disabled={isCertificationLock()
                                                                    || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                                onBlur={handleBlur}
                                                                onChange={(e) => updatePhoneExtension(e.currentTarget.value)}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {certOneAgree
                                                    ? <span>&#9745;</span>
                                                    : <span>&#9744;</span>}
                                                <span> I Agree to the Terms and Conditions above.</span>
                                            </Col>
                                        </Row>


                                    </CardBody>
                                </Card>
                            </Col>
                            <Col sm="1"></Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center pl-2 pr-3 py-1 my-1" >

                                {(totalErrorCount > 0) && !(utilityHelper.isLockedCertification(currentAfr, "")) &&
                                    (!(utilityHelper.evaluateAllSectionOK(loggedUser, currentAfr, entity, errorList, auditMessage, dispatch))) &&
                                    <Alert color="warning">
                                        <p><a className="anchorButton" onClick={handleClickShowErrors}>There are still outstanding items to complete prior to submitting the {reportTitle}.</a></p>
                                    </Alert>}
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center pl-2 pr-3" >
                                <p>
                                    <CanShowGivenAfrReportAccess>
                                        <Button
                                            className="btnSubmit"
                                            type="button"
                                            onClick={handleSaveClick}
                                            disabled={shouldDisableSubmit()}>{textButton}
                                        </Button>
                                    </CanShowGivenAfrReportAccess>
                                </p>
                            </Col>
                        </Row>

                    </Col>
                </Row>
                :
                <Row>
                    <Col>
                        <h3>This report has a signed template uploaded so manual Certification is not required.</h3>
                        <Row>
                            <Col className="d-flex justify-content-center pl-2 pr-3 py-1 my-1" >

                                {(totalErrorCount > 0) && !(utilityHelper.isLockedCertification(currentAfr, "")) &&
                                    (!(utilityHelper.evaluateAllSectionOK(loggedUser, currentAfr, entity, errorList, auditMessage, dispatch))) &&
                                    <Alert color="warning">
                                        <p><a className="anchorButton" onClick={handleClickShowErrors}>There are still outstanding items to complete prior to submitting the {reportTitle}.</a></p>
                                    </Alert>}
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center pl-2 pr-3" >
                                <p>
                                    <CanShowGivenAfrReportAccess>
                                        <Button
                                            className="btnSubmit"
                                            type="button"
                                            onClick={handleSaveClick}
                                            disabled={shouldDisableSubmit()}>{textButton}
                                        </Button>
                                    </CanShowGivenAfrReportAccess>
                                </p>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            }
        </React.Fragment>)

    return (
        isNotThirdParty ? (taxType === TaxonomyTypeEnum.COURT_REPORTING_29 ? isCR29Render : isNotThirdPartyRender) : isThirdPartyRender
    );
}

export default CertificationCore;